<script>
export default {
  name: 'CancelationRefund',
  props: {
    componentData: {
      type: Object,
      required: true,
    },
  },
}
</script>

<template>
  <div
    :class="$style.container">
    <div
      :class="$style.container__header">
      <h3>{{ componentData.title }}</h3>
    </div>
    <div
      :class="$style.container__content">
      <p v-html="componentData.body"/>
    </div>
  </div>
</template>

<style lang="scss" module scoped>
@import '@design';

.container {
  padding: 1.5rem;

  &__header {
    h3 {
      @extend %typography-medium;
      font-weight: bold;
      color: $darker-gray;
    }
  }

  &__content {
    @extend %typography-medium;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    text-align: center;
  }
}
</style>
